export const ADD_COMMENT = 'Add Comment';
export const BREAK = 'Break';
export const COPY_C2C_DIFF_RESULT_PATH = 'Copy C2C Diff Result Path';
export const COPY_DIFF_RESULT_PATH = 'Copy Diff Result Path';
export const COPY_FILE_PATH = 'Copy File Path';
export const COPY_FILE_PATH_EXPORT_TESTS = 'Copy File Path Export Tests';
export const COPY_TREE_FILE_PATH = 'Copy Product Tree Path';
export const COPY_LOG_FILE_PATH = 'Copy Log File Path';
export const COPY_METRICS_FILE_PATH = 'Copy Metrics File Path';
export const COPY_N2N_DIFF_RESULT_PATH = 'Copy N2N Diff Result Path';
export const OPEN_N2N_DIFF_RESULT_S3_PATH = 'Open N2N Diff Result S3 Path';
export const COPY_PERFORMANCE_METRICS_FILE_PATH = 'Copy Performance Metrics File Path';
export const DONT_KEEP_FOREVER = 'Don\'t Keep Forever';
export const KEEP_FOREVER = 'Keep Forever';
export const LABEL_AS_OUTLIER = 'Label As Outlier';
export const OPEN_DIFF_VIEWER = 'Open Diff Viewer';
export const OPEN_DIFF_VIEWER_C2C = 'Open Diff Viewer (C2C)';
export const OPEN_DIFF_VIEWER_N2N = 'Open Diff Viewer (N2N)';
export const OPEN_JOB_URL = 'Open Job URL';
export const OPEN_S3_PATH = 'Open S3 Path';
export const OPEN_CHILD_JOB_URL = 'Open Child Job URL (Type)';
export const SET_AS_BASELINE = 'Set as Baseline';

export const OPEN_JIRA_URL = 'Open Jira Ticket';
export const REMOVE_AS_OUTLIER = 'Remove as Outlier';
export const RETRIGGER = 'Retrigger';
export const RETRIGGER_SCENARIO = 'Retrigger Scenario';
export const RUN_WHATS_IN_JOB = 'Run What\'s in Job';
export const RUN_WHATS_IN_JOB_AXIOM = 'Run What\'s in Job (AXIOM)';
export const RUN_WHATS_IN_JOB_IEF = 'Run What\'s in Job (IEF)';
export const SHOW_COMMENTS = 'Show Comments';
export const SHOW_HISTORY = 'Show History';
export const VIEW_TEST_ARTIFACTS = 'View Test Artifacts';


// WEBPACK FOOTER //
// src/helpers/actionTypes.js